import { MemberDetail } from '@/features/members';

export default function TeamMemberRoute() {
  return <MemberDetail />;
}
